module.exports = __webpack_public_path__ + "assets/img/example1.a42df1fc.png";